
export interface IRaftCommand {
    getRaftUniqueRequestId(): string;
}